import { FormattedMessage } from 'react-intl';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { KitReturnStatusMessages, SlotSelectionContent } from '../kit-return/shared/kit-return-ui';
import { useConfirmKitReturnSlot } from './confirm-kit-return-slot.controller';

const ID = 'confirm-kit-return-slot';

export const ConfirmKitReturnSlot = () => {
    const viewProps = useConfirmKitReturnSlot();

    return (
        <WizardScreenContainer
            id={ID}
            header={{
                onBack: viewProps.onBack
            }}
            footer={{
                onBack: viewProps.onBack,
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled
            }}
            loadingModal={{ show: viewProps.isBusy }}
            errorModal={{
                show: !!viewProps.error,
                title: viewProps.errorTitle ?? (
                    <FormattedMessage
                        id='kiosk.wizard.kit-return-detail.cannot-continue-title'
                        description='Fallback title shown when a kit return cannot continue'
                        defaultMessage='Cannot continue'
                    />
                ),
                message: viewProps.error,
                onClose: viewProps.resetError
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-start justify-start gap-2 self-stretch overflow-y-scroll p-0'>
            {viewProps.status.kind === 'ready' ? (
                <SlotSelectionContent
                    groups={viewProps.slotSelectionGroups}
                    entries={viewProps.entries}
                    selectedSlotByEquipmentId={viewProps.selectedSlotByEquipmentId}
                />
            ) : (
                <div className='flex flex-1 flex-col items-start justify-start gap-4 self-stretch px-5 pt-6 pb-20'>
                    <KitReturnStatusMessages
                        status={viewProps.status}
                        retryLoad={viewProps.retryLoad}
                    />
                </div>
            )}
        </WizardScreenContainer>
    );
};

export default ConfirmKitReturnSlot;
